import type { Sites } from '@ps/platform-message-framework/common/Sites';

import type {
  BetSlipErrorConfig,
  ComplexBetSlipErrorConfig,
  SimpleBetSlipErrorConfig
} from '@swf/sports/config/bet-slip-errors';

const isComplexErrorConfig = (config: BetSlipErrorConfig): config is ComplexBetSlipErrorConfig =>
  'contentTranslationTag' in config;

const mapConfigToComplexBetSlipErrorConfig = (config: SimpleBetSlipErrorConfig) => ({
  contentTranslationTag: config
});

interface GetErrorConfigParams {
  config: BetSlipErrorConfig;
  siteId: Sites;
}

export const getErrorConfig = ({
  config,
  siteId
}: GetErrorConfigParams): ComplexBetSlipErrorConfig => {
  if (isComplexErrorConfig(config)) {
    return config.siteOverrides?.[siteId]
      ? {
          ...config,
          ...config.siteOverrides[siteId]
        }
      : config;
  }

  return mapConfigToComplexBetSlipErrorConfig(config);
};
